import {mapGetters} from "vuex"

export default {
  data() {
    return {
      addRightVisible: false,
    }
  },
  computed: {
    ...mapGetters('app', {mixinLocale: 'locale'}),
  },
  methods: {
    onCreateRight(data) {
      return this.$store.dispatch('app/createRight', data)
        .then((res) => {
          const mRes = Array.isArray(res) ? res[0] : res

          // Check for errors on the main row object
          let mainErrors = mRes.data.rows.map(r => (r.errflg == 1 && r.errormsg ? r.errormsg[this.mixinLocale] : null)).filter(e => e !== null)

          // Check for errors on indiviual fields and add to main errors
          for (const row of mRes.data.rows) {
            if (row.errors) {            
              const rowErrors = row.errors.map(r => (r.errormsg ? r.errormsg[this.mixinLocale] : null)).filter(e => e !== null)
              mainErrors = mainErrors.concat(rowErrors)
            }
          }

          // If we have any errors we wanna display unique error text plus number of occurrences of that error
          if (mainErrors.length) {
            var uniqErrors = mainErrors.reduce((acc, val) => {
              acc[val] = acc[val] === undefined ? 1 : acc[val] += 1
              return acc
            }, {});

            let errorString = ""
            for (const [key, value] of Object.entries(uniqErrors)) {
              errorString = `${errorString.length ? ', ' : ''}${key} (${value})`;
            }

            this.$toast(this.$t('rights.addForm.error', [errorString]))
          } else {
            this.$toast(this.$t('rights.addForm.done'));
          }
        })
    },
  }
}